import { useState, useEffect, useCallback } from 'react';
import CustomersModelMc from '../../models/v2/CustomersModelMc';

/**
 * Resolves customer record by caller phone for incoming WhatsApp call UI (all providers).
 */
export default function useCustomerData({ callInfoData, updateIncomingPhone }) {
  const [customer, setCustomer] = useState(null);
  const [error, setError] = useState(null);
  const [isLookupResolved, setIsLookupResolved] = useState(false);

  const fetchCustomer = useCallback(async () => {
    setError(null);
    setIsLookupResolved(false);
    try {
      const response = await CustomersModelMc.byPhone({ phone: callInfoData.callerNumber });
      if (response && response.customer) {
        setCustomer(response.customer);
        updateIncomingPhone(callInfoData.callId, {
          customer: response.customer
        });
      } else {
        setCustomer(null);
      }
    } catch (err) {
      setError(err.message || 'Error al buscar cliente');
      setCustomer(null);
    } finally {
      setIsLookupResolved(true);
    }
  }, [callInfoData.callerNumber, updateIncomingPhone, callInfoData.callId]);

  useEffect(() => {
    if (callInfoData.callerNumber) {
      fetchCustomer();
    } else {
      setIsLookupResolved(true);
      setCustomer(null);
    }
  }, [callInfoData.callerNumber, fetchCustomer]);

  return {
    customer,
    error,
    isLookupResolved,
    refresh: fetchCustomer
  };
}
